import { useEffect, useState } from "react";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";
import {
  getPremiumPlan,
  isActivePremiumPlan,
  deletePlan,
} from "../../store/premiumPlan/premiumPlan.action";
import Button from "../../Component/Common/Button";
import { ReactComponent as TrashIcon } from "../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/EditBtn.svg";
import AddIcon from "@mui/icons-material/Add";
import { connect, useDispatch, useSelector } from "react-redux";
import Table from "../../Component/Common/Table";
import dayjs from "dayjs";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import ToggleSwitch from "../../Component/Common/ToggleSwitch";
import { warning } from "../../util/Alert";
import CreatePremiumPlan from "../../Component/dialogue/CreatePremiumPlan";
import { getDefaultCurrency } from "../../store/currency/currency.action";

function PremiumPlan(props) {
  const { premiumPlanData } = useSelector(
    (state) => state.premiumPlan,
  );
  const { defaultCurrency } = useSelector((state) => state.currency);
  const { dialogueType } = useSelector((state) => state.dialogue);

  const dispatch = useDispatch();
  const [data, setData] = useState();

  const handleEdit = (row, type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handleOpenNew = (type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handleDeletePlan = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = row?._id;
            props.deletePlan(id);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const handleIsActive = (row) => {
    const id = row?._id;
    const data = row?.isActive === false ? true : false;
    props.isActivePremiumPlan(id, data);
  };

  const planTable = [
    {
      Header: "NO",
      body: "name",
      Cell: ({ index }) => <span>{index + 1}</span>,
    },

    {
      Header: "PLAN BENEFIT",
      body: "planBenefit",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          <ul>
            {row?.planBenefit?.map((detail, index) => (
              <li key={index}>{detail}</li>
            ))}
          </ul>
        </span>
      ),
    },
    {
      Header: "AMOUNT",
      body: "amount",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.amount + " " + defaultCurrency?.symbol}
        </span>
      ),
    },
    {
      Header: "VALIDITY",
      body: "validity",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.validity}</span>
      ),
    },
    {
      Header: "PRODUCT KEY",
      body: "productKey",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.productKey}</span>
      ),
    },
    {
      Header: "VALIDITY TYPE",
      body: "validityType",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.validityType}</span>
      ),
    },
    {
      Header: "CREATE DATE",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.createdAt ? dayjs(row?.createdAt).format("DD MMMM YYYY") : ""}
        </span>
      ),
    },
    {
      Header: "IS ENABLED",
      body: "isEnabled",
      Cell: ({ row }) => (
        <ToggleSwitch
          checked={row?.isActive}
          onChange={() => handleIsActive(row)}
        />
      ),
    },
    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row }) => (
        <div className="action-button">
          <Button
            className="icon-btn"
            startIcon={<EditIcon />}
            onClick={() => handleEdit(row, "premiumPlanAdd")}
          />
          <Button
            className="icon-btn"
            startIcon={<TrashIcon />}
            onClick={() => handleDeletePlan(row)}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    dispatch(getPremiumPlan());
    dispatch(getDefaultCurrency());
  }, [dispatch]);

  useEffect(() => {
    setData(premiumPlanData);
  }, [premiumPlanData]);

  return (
    <PageContainer className="premium-plan userPage withdrawal-page">
      {dialogueType == "premiumPlanAdd" && <CreatePremiumPlan />}

      <PageHeader heading={"Welcome Admin"} subHeading={"Premium Plan"} />

      <div className="payment-setting-box user-table">
        <div className="user-table-top">
          <div className="row">
            <div className="col-8">
              <h5
                style={{
                  fontWeight: "500",
                  fontSize: "20px",
                  marginBottom: "0px",
                  marginTop: "5px",
                  padding: "3px",
                }}
              >
                Premium Plan Table
              </h5>
            </div>
            <div className="col-4 d-flex justify-content-end">
              <Button
                className={"rounded"}
                startIcon={<AddIcon />}
                onClick={() => handleOpenNew("premiumPlanAdd")}
              >
                New
              </Button>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <Table
            data={data}
            mapData={planTable}
            noDataMessage={"No Plan Found!"}
          />
        </div>
      </div>
    </PageContainer>
  );
}
export default connect(null, {
  getPremiumPlan,
  isActivePremiumPlan,
  deletePlan,
})(PremiumPlan);
